import { apiIdp } from "./client";

export const LKFR_NOTIFICATION_ROLES = ["ROLE_USER", "ROLE_FR", "ROLE_FRANCHISEE"] as const;
export const LKFR_NOTIFICATIONS_UPDATED_EVENT = "chio:lkfr-notifications-updated";

export type NotificationInboxItem = {
    id: number | string;
    title: string;
    text: string;
    createdAt: string;
    isRead: boolean;
    type?: "promo" | "system" | "booking" | "other";
};

export type NotificationInboxResponse = {
    ok: boolean;
    items: NotificationInboxItem[];
    nextCursor: string | null;
    unreadCount?: number;
};

const PATH = "/api/client/notifications";

export function emitLkfrNotificationsUpdated(): void {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent(LKFR_NOTIFICATIONS_UPDATED_EVENT));
}

export async function fetchLkfrNotifications(limit: number, cursor?: string | null) {
    return await apiIdp.post<NotificationInboxResponse>(PATH, {
        roles: LKFR_NOTIFICATION_ROLES,
        limit,
        cursor: cursor ?? undefined,
    });
}

export async function markLkfrNotificationRead(id: number | string) {
    return await apiIdp.post<{ ok: boolean }>(`${PATH}/${id}/read`, {});
}
